/**
 * Auth Selectors
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

const selectAuthState = (state: RootState) => state.auth;

export const selectIsLoggedIn = createSelector([selectAuthState], (auth) => auth.isLoggedIn);

export const selectIsAuthLoading = createSelector([selectAuthState], (auth) => auth.isLoading);

export const selectIsAuthChecked = createSelector([selectAuthState], (auth) => auth.isAuthChecked);
